// Method: Convert date to '08:30 am'
export const useFormatCurrency = (amount?: number) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount ?? 0)
}